let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cgGsl")).then(() => parcelRequire('aA2px'));